import React from "react";
import DownloadCollapsePanel from "../Joyspace/components/BatchDownloadPanel";
import JoySpaceUploadBox from "../Joyspace/components/UploadBox";
import "./index.less";

// DownloadCollapsePanel 协同文档模块用 JoySpaceUploadBox上传所有模块用
const GlobalFTPCollapsePanel = () => {
  return (
    <div className="joyspace-global-collapse">
      <JoySpaceUploadBox />
      <DownloadCollapsePanel className="joyspace-download" />
    </div>
  );
};

export default GlobalFTPCollapsePanel;
